// AdminLayout — sidebar nav + shell for the admin role.
import { NavLink, Outlet } from "react-router-dom";

const NAV_ITEMS = [
  { to: "/app/admin",              label: "Dashboard",    end: true },
  { to: "/app/admin/users",        label: "Users",        end: false },
  { to: "/app/admin/courses",      label: "Courses",      end: false },
  { to: "/app/admin/payments",     label: "Payments",     end: false },
  { to: "/app/admin/certificates", label: "Certificates", end: false },
];

export default function AdminLayout() {
  return (
    <div className="dm-layout">
      <nav className="w-56 shrink-0 bg-dm-navy text-white p-4 space-y-1">
        <p className="text-xs uppercase tracking-wide text-white/50 px-2 mb-3">Admin</p>
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `block rounded-md px-3 py-2 text-sm ${isActive ? "bg-dm-blue text-white" : "text-white/80 hover:bg-dm-blue/50"}`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      <main className="dm-main"><Outlet /></main>
    </div>
  );
}
